<template>
  <div :style="backgroundColor" id="overlay" v-if="show">
    <div class="lds-ripple" v-if="isLoading">
      <div></div>
      <div></div>
    </div>
    <svg fill="#fff" viewBox="0 0 24 24" v-if="!isLoading">
      <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    value: Boolean,
    bgColor: String,
    isLoading: Boolean,
    isConfirm: Boolean
  },
  computed: {
    backgroundColor () {
      return `background-color:${this.hexToRgbA(this.bgColor)};`
    },
    show: {
      get () { return this.value },
      set (value) { this.$emit('input', value) }
    }
  },
  watch: {
    isLoading (newValue) {
      if (!newValue) {
        const self = this
        setTimeout(() => {
          self.show = false
          self.$emit('spinnerClosed')
        }, 1000)
      }
    }
  },
  methods: {
    hexToRgbA: hex => {
      let c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ', 0.97)'
      }
    }
  }
}
</script>
<style scoped>
svg {
  animation: finish 0.5s cubic-bezier(0, 0.2, 0.8, 1);
  width:90px;
  height:90px;
}
@keyframes finish {
  0% {
    width: 0;
    height: 0;
    opacity: 0;
  }
  100% {
    width: 90px;
    height: 90px;
    opacity: 1;
  }
}
#overlay {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: fixed;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.lds-ripple {
  position: relative;
  width: 90px;
  height: 90px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 45px;
    left: 45px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 90px;
    height: 90px;
    opacity: 0;
  }
}
</style>
